<div class="row form-group" [class.invalid]="!valid">

  <div class="form-group col-sm-6" [class.invalid]="overlapError">
    @if (showLabel) {
      <label>Start date</label>
    }
    <app-utc-date-picker [placeholder]="'Choose start date'" [min]="fromMin" [max]="fromMax" [readonly]="readonly"
      [(ngModel)]="fromDate" (ngModelChange)="validate()">
    </app-utc-date-picker>
  </div>

  <div class="form-group col-sm-6">
    @if (showLabel) {
      <label> End date</label>
    }
    <app-utc-date-picker [placeholder]="'Choose end date'" [min]="toMin" [max]="toMax" [readonly]="readonly"
    [(ngModel)]="toDate" (ngModelChange)="validate()"></app-utc-date-picker>
  </div>
</div>

<app-collapsible [trigger]="!valid">
  @for (message of errorMessages; track message) {
    <p class="form-error">
      {{ message }}
    </p>
  }
</app-collapsible>
<app-collapsible [trigger]="overlapError">
  <p class="form-error">
    {{ overlapErrorMessage || 'Dates must not overlap' }}
  </p>
</app-collapsible>